import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { Document } from "le-coffre-resources/dist/SuperAdmin";
import type { ApiPayload, QueryPayload } from "@Front/Api/types";
import type { IGetDocumentsparams, IPutDocumentsParams } from "../Documents";
import {
	buildDocumentsCreatePayload,
	buildDocumentsUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (q: IGetDocumentsparams): Promise<Document[]> => {
		const url = new URL(baseUrl);
		const query = { q };
		if (q) baseAdmin.appendJsonSearchParams(url, query);
		try {
			return await baseAdmin.getRequest<Document[]>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (body: ApiPayload): Promise<Document> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildDocumentsCreatePayload(body);
			return await baseAdmin.postRequest<Document>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<Document> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		const query = { q };
		if (q) baseAdmin.appendJsonSearchParams(url, query);
		try {
			return await baseAdmin.getRequest<Document>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, body: IPutDocumentsParams): Promise<Document> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildDocumentsUpdatePayload(body);
			return await baseAdmin.putRequest<Document>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDeleteMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string): Promise<Document> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			return await baseAdmin.deleteRequest<Document>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}
